import { render, staticRenderFns } from "./HappyHolidaysCheckout.vue?vue&type=template&id=3155adbc&scoped=true&"
import script from "./HappyHolidaysCheckout.vue?vue&type=script&lang=js&"
export * from "./HappyHolidaysCheckout.vue?vue&type=script&lang=js&"
import style0 from "./HappyHolidaysCheckout.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./HappyHolidaysCheckout.vue?vue&type=style&index=1&id=3155adbc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3155adbc",
  null
  
)


    import installComponents from "!/Users/leandrosehnembortolotto/Development/Dropsmart/dropsmith-frontend-v2/node_modules/bootstrap-vue-loader/lib/runtime/installComponents.js"
    import {BCol, BRow, BContainer} from 'bootstrap-vue'
    installComponents(component, {BCol, BRow, BContainer})
    

export default component.exports